import { render } from "./ApplicantIdentityList.vue?vue&type=template&id=15946ef6"
import script from "./ApplicantIdentityList.vue?vue&type=script&lang=js"
export * from "./ApplicantIdentityList.vue?vue&type=script&lang=js"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__